/**
 * Interface for the Board data. This must be in sync with the backend: "db.php"
 */

interface IBoardData {
    ID: string;
    Name: string;
    OverrideNames: string[];
    GrossSheetPrice: number | null;
    GrossUnitPrice: number | null;
    Materials: any; // The configurator ignores this field
    ProductImage: string;
    SheetWidth: number;
    SheetHeight: number;
    SheetThickness: number;
    CompatibleEdgings: string[] | null;
    Oriented: number; // TODO: This should be a boolean
    EdgeBandable: number; // TODO: This should be a boolean
    Duplungable: number; // TODO: This should be a boolean
    IsWorkTop?: number | boolean; // TODO: This should be a boolean
    Core?: string | null;
    CalcMethod?: string | null;
}

export default IBoardData;
